export const FOLDER_PREPARATION_PAUSED = 'Folder OCR preparation paused after the current chunk.';
/** Electron prefixes remote exceptions with the channel name. */
export const isFolderPreparationPaused = (message: string): boolean =>
  message.endsWith(FOLDER_PREPARATION_PAUSED);
